import * as DateFormatter from "../../../utils/DateFormatter";
import {ResponsiveSize} from "../../../utils/ResponsiveHelper";

export default class BatchBankCard {
  constructor(jsonResponse) {
    this.id = jsonResponse["id"];
    this.barcode = jsonResponse["barcode"];
    this.cardBatchId = jsonResponse["card-batch-id"];
    this.dateCreated = jsonResponse["date-created"];
    this.dateCreatedFormatted = DateFormatter.prettifyDate(jsonResponse["date-created"]);
    this.assignedToAgent = jsonResponse["assigned-to-agent"];
    this.assignedToCustomer = jsonResponse["assigned-to-customer"];
    this.assignedUserId = jsonResponse["assigned-user-id"];
    this.assignedUsername = jsonResponse["assigned-username"];
    this.bankCardId = jsonResponse["bank-card-id"];
    this.assigningUserId = jsonResponse["assigning-user-id"];
    this.packaged = jsonResponse["packaged"];
  }

  static getColumnConfig = function (){
    return [
      {
        dataField: "id",
        header: "Id",
        width: "90px",
        hidden :ResponsiveSize.XS
      },
      {
        dataField: "barcode",
        header: "Barcode"
      },
      {
        header: "Assigned Agent",
        dataField: "assignedUsername"
      },
      {
        header: "Allocated To Customer",
        dataField: "assignedToCustomer",
        type: "boolean",
        hidden :ResponsiveSize.XS
      }
    ];
  };
}
